import {
  ApiSlugs,
  ListPagination,
  ReconcileStripeSubscriptionsRequestDto,
  ReconcileStripeSubscriptionsResponseDto,
  SubscriptionId,
  SubscriptionSummaryDto,
} from '@workspace/data-types';
import { Observable } from 'rxjs';
import { ApiCaller } from '../../../api-caller.service';
import { ApiConnector } from '../../../api-connector.abstract-service';
import { QueryParamsUtils } from '../../../utils/query-params.utils';

export class SubscriptionsAdminConnector extends ApiConnector<
  SubscriptionSummaryDto,
  SubscriptionSummaryDto,
  SubscriptionId
> {
  constructor(apiCaller: ApiCaller, apiPrefix: string) {
    super(apiCaller, apiPrefix, ApiSlugs.SUBSCRIPTIONS);
  }

  reconcile(hours: number): Observable<ReconcileStripeSubscriptionsResponseDto> {
    const body: ReconcileStripeSubscriptionsRequestDto = { hours };
    return this.apiCaller.postRequest<ReconcileStripeSubscriptionsResponseDto>(
      this.apiPrefix,
      `${this.slug}/reconcile`,
      body,
    );
  }

  cancel(subscriptionId: SubscriptionId): Observable<SubscriptionSummaryDto> {
    return this.apiCaller.postRequest<SubscriptionSummaryDto>(
      this.apiPrefix,
      `${this.slug}/${subscriptionId}/cancel`,
      {},
    );
  }

  summerized = () => ({
    list: (pagination?: ListPagination): Observable<SubscriptionSummaryDto[]> =>
      this.apiCaller.getRequest<SubscriptionSummaryDto[]>(
        this.apiPrefix,
        `${this.slug}/all${QueryParamsUtils.buildFilterParams(pagination)}`,
      ),
    count: (pagination?: ListPagination): Observable<number> =>
      this.apiCaller.getRequest<number>(
        this.apiPrefix,
        `${this.slug}/all/count${QueryParamsUtils.buildFilterParams(pagination, true)}`,
      ),
  });
}
